export const routes = {
  CONTACT_INQUIRY_SUBMIT: "contact-requests",
  TESTIMONIALS: "testimonials",
  HOME_TESTIMONIALS: "testimonials/display-on-homepage",
  PORTFOLIOS: "portfolios",
  TECHNOLOGY_DROPDOWN: "technologies/drop-down",
  INDUSTRY_DROPDOWN: "industries/drop-down",
  PLATFORM_DROPDOWN: "platforms/drop-down",
  META_INFO: "seo-config",
  USA_MEETING: "usa-meeting"
}
